import $ from 'jquery';

$(function () {
    if ($('.localplanwatchlandingpage').length) {

        $('.main-map svg #Counties > g').on('mouseover',
            function () {
                let $this = $(this);
                $this.find('polyline, polygon').addClass('hover');
            })
            .on('mouseout', function () {
                let $this = $(this);
                $this.find('polyline, polygon').removeClass('hover');
            });

        let counties = $('.main-map').data('counties');
        $('.main-map.landing svg #Counties g, .main-map.landing svg #Areas g').on('click',
            function () {
                let $this = $(this);
                for (let i = 0; i < counties.length; i++) {
                    if ($this.prop('id') == counties[i].id) {
                        window.location = counties[i].link;
                        window.status = counties[i].link; // unlikely this will work in most browsers
                    }
                }
            });
    }

    if ($('.localplanwatchcountypage').length) {
        let areas = $('.main-map').data('areas');

        // Position 'A's
        $('.main-map svg #Areas g.alp').each(function (i, e) {
            let text = $('text', e)[0];
            let textBbox = text.getBBox();

            let circle = $('circle', e)[0];
            circle.setAttribute('cx', Number(circle.getAttribute('cx')) + (textBbox.width / 2));
            circle.setAttribute('cy', Number(circle.getAttribute('cy')) + textBbox.height + 5);
            //circle.setAttribute('style', 'display:none');
        });

        $('.main-map svg #Areas g text, .main-map svg #Areas g circle')
            .on('mouseover',
                function () {
                    let $this = $(this);
                    $this.parent().find('polygon, path').addClass('hover');
                })
            .on('mouseout',
                function () {
                    let $this = $(this);
                    $this.parent().find('polygon, path').removeClass('hover');
                });

        //main-map svg polygon.cls-5, 
        $('.main-map svg #Areas g').on('click',
            function () {
                let id = $(this).prop('id');
                for (let i = 0; i < areas.length; i++) {
                    if (id === areas[i].id) {
                        let area = areas[i];

                        let $modal = $('#areaDetailModal');
                        $('.heading', $modal).text(area.name);
                        if (area.hasA) {
                            $('.ap-icon', $modal).prop('style', '');
                        } else {
                            $('.ap-icon', $modal).prop('style', 'display:none;');
                        }
                        $('.intro', $modal).text(area.intro);
                        $('.body', $modal).html(area.bodyContent);
                        if (area.contact != null) {
                            $('.contact', $modal).removeClass('hide').html('<p>' + area.contact + '<br/><a href=mailto:' + area.email + '>' + area.email + '</a></p>');
                        } else {
                            $('.contact', $modal).addClass('hide').html('');
                        }

                        $modal.foundation('open');
                    }
                }
            });
    }
});